import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { closeModalEmail, changeEmailModalAttr } from '../../../actions/comparisonActions';
import { sendEmail } from '../../../apiCalls';

import { getUrlParams } from '../../../utils'
import { Loading } from '../../standard/loading/Loading';


export class ModalEmail extends Component {
    constructor(props) {
        super(props);

        if (props.type === 'comparison')
            this.state = {
                title: 'Enviar comparação por email',
                defaultMsg: 'Envie essa comparação do seu Seguro Viagem por e-mail e acesse quando quiser.',
                successMsg: 'Comparação enviada com sucesso!',
                errorMsg: 'Houve um problema no envio do email! :('
            }
        else if (props.type === 'detail')
            this.state = {
                title: 'Enviar cobertura por e-mail',
                defaultMsg: 'Envie essa cobertura do seguro viagem por e-mail e acesse quando quiser',
                successMsg: 'Detalhes do Plano enviados com sucesso!',
                errorMsg: 'Houve um problema no envio do email! :('
            }

        this.sendEmail = this.sendEmail.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        const field = { name: e.target.name, value: e.target.value };
        this.props.changeEmailModalAttr(field);
    }

    sendEmail() {
        let pageParams = { ...this.props.match.params };
        if (this.props.type === 'comparison')
            pageParams = { ...this.props.match.params, products_ids: getUrlParams().products_ids.replace(/%20/g, '+').split('+') };

        sendEmail(
            pageParams,
            this.props.type,
            this.props.emailModal.emailAddress
        );
    }

    render() {
        if (!this.props.isModalEmailActive)
            return <div />

        return (
            <div className="comp_modalemail">
                <div className="modalbody">
                    <button className="modalheader" onClick={this.props.closeModalEmail}>
                        <img src="/assets/images/icons/circleClose.svg" alt="fechar" />
                    </button>

                    <img src="/assets/images/icons/plane.svg" alt="enviar email" />

                    <h2 className="modaltitle">
                        {this.state.title}
                    </h2>
                    <span className="modalcontent">

                        {this.props.emailStatus === 'done' &&
                            <span>{this.state.successMsg}</span>
                        }
                        {this.props.emailStatus === 'fail' &&
                            <span>{this.state.errorMsg}</span>
                        }
                        {this.props.emailStatus === '' &&
                            <span>{this.state.defaultMsg}</span>
                        }
                    </span>

                    {this.props.emailStatus === 'sending' &&
                        <Loading />
                    }

                    {this.props.emailStatus !== 'sending' &&
                        (
                            <div className='modal-input-group'>
                                <input
                                    key="modal-input"
                                    type="text"
                                    name="emailAddress"
                                    className="modalinput"
                                    value={this.props.email}
                                    onChange={this.handleChange}
                                    placeholder="Seu e-mail" />
                                <button
                                    key="modal-button"
                                    className="modalbutton"
                                    onClick={this.sendEmail}>
                                    <span className="modalbutton_span">Enviar</span>
                                </button>
                            </div>
                        )
                    }

                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        emailModal: state.comparison.emailModal,
        emailStatus: state.comparison.emailStatus,
        isModalEmailActive: state.comparison.isModalEmailActive,
    }),
    {
        closeModalEmail,
        changeEmailModalAttr,
    }
)(withRouter(ModalEmail))



// WEBPACK FOOTER //
// ./src/components/comparison/modal_email/ModalEmail.jsx